import React from 'react';
import { useForm } from 'react-hook-form';
import { useParams, useNavigate, useSearchParams, Link } from 'react-router-dom';
import { publicApi } from '../../config/axios';
import { useGlobal } from '../../contexts/GlobalContext';
import { useDocumentTitle } from '../../config/utils';
import logo from '../../assets/img/logo.png';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';

export default function ResetPassword() {
  useDocumentTitle('Reset Password');
  const { token }     = useParams();
  const [search]       = useSearchParams();
  const emailFromLink  = search.get('email') || '';
  const navigate      = useNavigate();
  const { showToast } = useGlobal();
  const [formError, setFormError] = React.useState('');
  const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm();

  const onSubmit = async (data) => {
    setFormError('');
    try {
      await publicApi.post(`/users/reset-password/${token}`, { ...data, email: emailFromLink || data.email });
      showToast('success', 'Password Reset', 'Your password has been reset successfully.');
      navigate('/');
    } catch (err) {
      const body = err?.response?.data; const first = body?.errors ? Object.values(body.errors)[0] : null;
      setFormError((Array.isArray(first) ? first[0] : first) || body?.message || 'Reset failed.');
    }
  };

  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <img src={logo} alt="PopupPush" className="h-10 mx-auto mb-6" />
          <h2 className="text-2xl font-bold text-text-main">Set new password</h2>
          <p className="text-text-muted text-sm mt-1">Must be at least 8 characters.</p>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-5 card-padded">
          {formError && <div role="alert" data-testid="reset-error" className="rounded-lg px-4 py-3 text-sm" style={{ background: 'rgba(220,38,38,.12)', border: '1px solid rgba(239,68,68,.5)', color: '#fecaca' }}>{formError}</div>}
          {!emailFromLink && (
            <Input label="Email address" type="email" placeholder="admin@example.com" error={errors.email?.message}
              {...register('email', { required: 'Email is required' })} />
          )}
          <Input
            label="New Password"
            type="password"
            placeholder="··········"
            error={errors.password?.message}
            {...register('password', {
              required: 'Password is required',
              minLength: { value: 8, message: 'Minimum 8 characters' },
            })}
          />
          <Input
            label="Confirm Password"
            type="password"
            placeholder="··········"
            error={errors.password_confirmation?.message}
            {...register('password_confirmation', {
              required: 'Please confirm your password',
              validate: v => v === watch('password') || 'Passwords do not match',
            })}
          />
          <Button type="submit" loading={isSubmitting} className="w-full justify-center">
            Reset Password
          </Button>
          <p className="text-center text-sm text-text-muted">
            <Link to="/" className="text-accent hover:underline">Back to Sign In</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
